import { createReducer, on } from '@ngrx/store';
import * as RiderAuthenticationActions from '@uzurv/rideWss/app/store/rider-authentication/rider-authentication.action';
import { CardType, PaymentAccount, PaymentMethod } from '@uzurv/rideWss/clara';
import * as PaymentActions from './payment.actions';
import { PaymentState } from './payment.state';

export const paymentFeatureKey = 'payment';

export const initialState: PaymentState = {
  paymentAccounts: new Array<PaymentAccount>(),
  lastUsedPaymentAccount: null,
  paymentMethods: new Array<PaymentMethod>(),
  cardTypes: new Array<CardType>(),
  isPaymentAccountActionInProgress: false,
  paymentAccountsLoading: false,
  paymentAccountsRefreshing: false,
  paymentMethodsLoading: false,
  cardTypesLoading: false,
  disableSubmit: false,
  isOutstandingChargesLoaded: false,
  outstandingCharges: null
};

export const reducer = createReducer(
  initialState,
  on(PaymentActions.fetchPaymentAccounts, (state) => {
    return {
      ...state,
      paymentAccountsLoading: true
    };
  }),

  on(PaymentActions.refreshPaymentAccounts, (state, action) => {
    return {
      ...state,
      paymentAccountsRefreshing: true
    };
  }),

  on(PaymentActions.fetchPaymentAccountsSuccess, (state, action) => {
    return {
      ...state,
      paymentAccounts: action.paymentAccounts,
      paymentAccountsLoading: false,
      paymentAccountsRefreshing: false
    };
  }),

  on(PaymentActions.fetchLastUsedPaymentAccountSuccess, (state, action) => {
    return {
      ...state,
      lastUsedPaymentAccount: action.paymentAccount
    };
  }),

  on(PaymentActions.fetchLastUsedPaymentAccountFail, (state, action) => {
    return {
      ...state,
      lastUsedPaymentAccount: null
    };
  }),

  on(PaymentActions.addPaymentAccount, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: true
    };
  }),

  on(PaymentActions.addPaymentAccountSuccess, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: false
    };
  }),

  on(PaymentActions.addPaymentAccountFail, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: false
    };
  }),

  on(PaymentActions.updatePaymentAccount, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: true
    };
  }),

  on(PaymentActions.updatePaymentAccountSuccess, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: false
    };
  }),

  on(PaymentActions.updatePaymentAccountFail, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: false
    };
  }),

  on(PaymentActions.deletePaymentAccount, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: true
    };
  }),

  on(PaymentActions.deletePaymentAccountSuccess, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: false
    };
  }),

  on(PaymentActions.deletePaymentAccountFail, (state, action) => {
    return {
      ...state,
      isPaymentAccountActionInProgress: false
    };
  }),

  on(PaymentActions.fetchPaymentMethods, (state, action) => {
    return {
      ...state,
      paymentMethodsLoading: true
    };
  }),

  on(PaymentActions.fetchPaymentMethodsSuccess, (state, action) => {
    return {
      ...state,
      paymentMethods: action.paymentMethods,
      paymentMethodsLoading: false
    };
  }),

  on(PaymentActions.fetchPaymentMethodsFail, (state, action) => {
    return {
      ...state,
      paymentMethodsLoading: false
    };
  }),

  on(PaymentActions.fetchCardTypes, (state, action) => {
    return {
      ...state,
      cardTypesLoading: true
    };
  }),

  on(PaymentActions.fetchCardTypesSuccess, (state, action) => {
    return {
      ...state,
      cardTypes: action.cardTypes,
      cardTypesLoading: false
    };
  }),

  on(PaymentActions.fetchCardTypesFail, (state, action) => {
    return {
      ...state,
      cardTypesLoading: false
    };
  }),

  on(PaymentActions.fetchOutstandingCharges, (state, action) => {
    return {
      ...state,
      isOutstandingChargesLoaded: false
    };
  }),

  on(PaymentActions.fetchOutstandingChargesSuccess, (state, action) => {
    return {
      ...state,
      outstandingCharges: action.charges,
      isOutstandingChargesLoaded: true
    };
  }),

  on(PaymentActions.fetchOutstandingChargesFail, (state, action) => {
    return {
      ...state,
      isOutstandingChargesLoaded: true
    };
  }),

  // Clear data on logout
  on(RiderAuthenticationActions.logoutSuccess, (state, action) => {
    return initialState;
  })
);
